import { deepClone } from "../array.utils";
import { getApp, getPageLocation, getPagePath, getPageTitle, } from "../utils/url";
import { getUserProfileId } from "../user/user-store";
export const eventDetails = (payload, eventType) => {
    const clone = deepClone(payload);
    return Object.assign(Object.assign({}, clone), { uiPath: getPagePath(), uiLocation: getPageLocation(), uiTitle: getPageTitle(), ui: getApp(), userProfileId: getUserProfileId(), type: eventType });
};



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/event-details/event-details.js
// module id = ./node_modules/@celine/passive-tracking/dist/event-details/event-details.js
// module chunks = 0